import yall from "yall-js";

export function useLazyLoading() {
    yall({
        observeChanges: true,
    });
    useLazyLoadingBackgroundImages();
}

export function useLazyLoadingBackgroundImages() {
    const elements = document.getElementsByClassName("lazy-bg");
    if (!elements.length) return;

    for (let i = 0; i < elements.length; i++) {
        const element = elements[i] as HTMLElement;
        const url = element.attributes["data-src"].value;
        if (url) {
            element.style.backgroundImage = `url("${url}")`;
        }
    }
}
